export const OPEN = '1983C67086D';
export const EINRICHTERFREIGABE = '1987425EDA0';
export const FINISHED = '1983C6726B8';
export const IN_PRODUKTION = '198742603C7';
export const GESTOPPT = '19874261814';
export const ABRUESTEN = '1987426285E';
